import { ImageOff, ShieldAlert } from 'lucide-react';
import { LibraryRiskOptin } from './LibraryRiskOptin';
import { libraryUploadRiskMessages } from './libraryUploadRisk.messages';

interface LibraryUploadRiskOptinProps {
  /** Current checkbox state, owned by the parent so it can reset on reopen. */
  accepted: boolean;
  onAcceptedChange: (accepted: boolean) => void;
  /** Confirms the opt-in. Only invokable once the checkbox is ticked. */
  onConfirm: () => void;
  /** Optional dismiss action; when omitted the cancel button is hidden. */
  onCancel?: () => void;
}

/**
 * Risk opt-in step for library document uploads (EVI-1566, EV-020).
 *
 * Thin wrapper around {@link LibraryRiskOptin} that supplies the document-upload
 * copy. Rendered inline inside the Upload Documents modal and the New Collection
 * Documents tab, only when the user has not previously accepted.
 */
export const LibraryUploadRiskOptin = ({
  accepted,
  onAcceptedChange,
  onConfirm,
  onCancel,
}: LibraryUploadRiskOptinProps) => (
  <LibraryRiskOptin
    intro={libraryUploadRiskMessages.modalIntro}
    bullets={[
      {
        icon: (
          <ShieldAlert size={20} className="mt-0.5 shrink-0 text-validation-warning" />
        ),
        message: libraryUploadRiskMessages.riskClinicalSafety,
      },
      {
        icon: <ImageOff size={20} className="mt-0.5 shrink-0 text-validation-warning" />,
        message: libraryUploadRiskMessages.riskImages,
      },
    ]}
    checkboxLabel={libraryUploadRiskMessages.acceptCheckboxLabel}
    confirmLabel={libraryUploadRiskMessages.acceptButton}
    cancelLabel={libraryUploadRiskMessages.cancelButton}
    checkboxId="library-upload-risk-accept"
    confirmTestId="library-upload-risk-accept-button"
    accepted={accepted}
    onAcceptedChange={onAcceptedChange}
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);
